import axios from 'axios'
import { API_URL2 } from './constants'

const API2 = axios.create({
    baseURL:`${API_URL2[process.env.NODE_ENV]}`
})

export default API2;